export default (restServer) => ({
    RESOLVE_CONFLICT: (resolution) => restServer(`/internal/api/utility/resolveConflict?resolution=${resolution}`, { method: "POST", ignoreAuth: true }),
    LOGOUT: () => restServer("/internal/api/utility/logout", {
        method: "POST",
        ignoreAuth: true,
    }),
    HEARTBEAT_PATH: () => "/internal/api/utility/heartbeat",
});
